

<template>
  <DBox
    :id="'cmp-distribution-order-delivery_address'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('address')}`"
    @add_click="onChangeAddress"
    v-if="
      selectedOrder &&
      selectedOrder.order_details_tab_summary &&
      selectedOrder.order_details_tab_summary.order
    "
  >
    <Dropdown2
      id="deliver_address_type"
      :label="$dft.capHead($t('Address Type'))"
      :placeholder="'Select ' + $dft.capHead($t('Address Type'))"
      :disabled="false"
      :options="addressTypeTV || []"
      :selected="
        addressTypeTV.find(
          (e) =>
            e.value ==
            selectedOrder.order_details_tab_summary.order.deliver_address_type
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('deliver_address_type', e)"
    />
    <TextField2
      id="deliver_company"
      :placeholder="$t('company_name')"
      :label="$t('company_name')"
      :value="selectedOrder.order_details_tab_summary.order.deliver_company"
      @blur="(e) => onTextFieldValueChange(e)"
    />
    <TextField2
      id="deliver_name"
      :placeholder="$t('name')"
      :label="$t('name')"
      :value="selectedOrder.order_details_tab_summary.order.deliver_name"
      @blur="(e) => onTextFieldValueChange(e)"
    />

    <TextField2
      id="deliver_address1"
      :placeholder="$t('Address 1')"
      :label="$t('Address 1')"
      :value="selectedOrder.order_details_tab_summary.order.deliver_address1"
      @blur="(e) => onTextFieldValueChange(e)"
    />

    <TextField2
      id="deliver_address2"
      :placeholder="$t('address_2')"
      :label="$t('address_2')"
      :value="selectedOrder.order_details_tab_summary.order.deliver_address2"
      @blur="(e) => onTextFieldValueChange(e)"
    />

    <TextField2
      id="deliver_phone"
      :placeholder="$t('phone')"
      :label="$t('phone')"
      :value="selectedOrder.order_details_tab_summary.order.deliver_phone"
      @blur="(e) => onTextFieldValueChange(e)"
    />

    <TextField2
      id="deliver_city"
      :placeholder="$t('city')"
      :label="$t('city')"
      :value="selectedOrder.order_details_tab_summary.order.deliver_city"
      @blur="(e) => onTextFieldValueChange(e)"
    />

    <TextField2
      id="deliver_postalcode"
      :placeholder="$t('postalcode')"
      :label="$t('postalcode')"
      :value="selectedOrder.order_details_tab_summary.order.deliver_postalcode"
      @blur="(e) => onTextFieldValueChange(e)"
    />

    <Dropdown2
      id="deliver_country"
      :label="$dft.capHead($t('country'))"
      :placeholder="'Select ' + $dft.capHead($t('country'))"
      :disabled="false"
      :options="countryTV || []"
      :selected="
        countryTV.find(
          (e) =>
            e.value ==
            selectedOrder.order_details_tab_summary.order.deliver_country
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('deliver_country', e)"
    />

    <TextField2
      id="vat_territory"
      :placeholder="$t('vat_territory')"
      :label="$t('vat_territory')"
      :value="selectedOrder.order_details_tab_summary.order.vat_territory"
      @blur="(e) => onTextFieldValueChange(e)"
      lw="115px"
      cw="280px"
      :icon="'search-blue-padded'"
      @iconClick="searchVatClick"
    />
  </DBox>
</template>

<script>
import TextField from "@plugins/text-field/text-field";
import Dropdown from "@plugins/dropdown/dropdown";
import { createTextFieldConfig, EventHooks } from "@plugins/text-field";
import { createDropdownConfig } from "@/plugins/dropdown";
import { DistributionStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters } from "vuex";
import * as ActionTypes from "../../store/types";
// import AddDeliveryAddress from "./add-delivery-address";
import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import { OrderService } from "../../services/order.service";
import { createTV } from "../../../../models/text-value.model";
import { createCountriesTV } from "../../../../models/country.model";
export default {
  components: {
    TextField,
    Dropdown,
    //AddDeliveryAddress,
  },
  props: {
    selectedOrder: {
      type: Object,
    },
  },
  data: function () {
    return {
      // Mark: Data
    };
  },
  mounted: function () {},
  watch: {},
  computed: {
    addressTypeTV: function () {
      return createTV(
        this.selectedOrder?.get_delivery_address?.address_types,
        "value",
        "value"
      );
    },
    countryTV: function () {
      return createCountriesTV(this.selectedOrder?.get_delivery_address?.countries);
      // return this.selectedOrder
      //   ? this.selectedOrder?.get_delivery_address?.countries.map((c) => {
      //       return {
      //         text: c,
      //         value: c,
      //       };
      //     })
      //   : [];
    },
  },

  methods: {
    onTextFieldValueChange: function (e) {
      const payload = {
        name: e.name,
        value: e.value,
      };
      this.$emit("changed", payload);
    },

    onDropdownChange: function (name, e) {
      const payload = {
        name: name,
        value: e.value,
      };
      this.$emit("changed", payload);
      console.log("WERERTYUPOIUN", payload);
    },
    searchVatClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "vat_territory_modal",
          order_id:
            this.selectedOrder?.order_details_tab_summary?.order.order_id,
        },
      });
    },

    onChangeAddress: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_contact_relation",
          external_id:
            this.selectedOrder?.order_details_tab_summary?.order.order_id,
          external_table: "l_orders",
          key: "delivery_id",
          config_type: "DistributionOrderDeliveryConfig",
        },
      });
    },
  },
};
</script>
